// extracted by mini-css-extract-plugin
module.exports = {"root":"Drawer_root__Q2ZoG","slideInRight":"Drawer_slideInRight__3jb1Z","hidden":"Drawer_hidden__230a7","slideInLeft":"Drawer_slideInLeft__3-ojE","spin":"Drawer_spin__eOGpG"};